import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

const codeScanningTab = EntityContentBlueprint.make({
  name: 'repository-security-insights',
  params: {
    path: 'security-insights',
    title: 'Security Insights',
    filter: 'kind:repository',
    loader: () =>
      import('@roadiehq/backstage-plugin-security-insights').then(m => (
        <m.EntitySecurityInsightsContent />
      )),
  },
});

const dependabotTab = EntityContentBlueprint.make({
  name: 'repository-dependabot',
  params: {
    path: 'dependabot',
    title: 'Dependabot',
    filter: 'kind:repository',
    loader: () =>
      import('@roadiehq/backstage-plugin-security-insights').then(m => (
        <m.EntityGithubDependabotContent />
      )),
  },
});

const codeScanningCard = EntityCardBlueprint.make({
  name: 'security-insights-code-scanning',
  params: {
    filter: 'kind:repository',
    type: 'info',
    loader: () =>
      import('@roadiehq/backstage-plugin-security-insights').then(m => (
        <m.EntitySecurityInsightsCard />
      )),
  },
});

const dependabotAlertsCard = EntityCardBlueprint.make({
  name: 'security-insights-dependabot',
  params: {
    filter: 'kind:repository',
    type: 'info',
    loader: () =>
      import('@roadiehq/backstage-plugin-security-insights').then(m => (
        <m.EntityDependabotAlertsCard />
      )),
  },
});

export const securityInsightsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    codeScanningTab,
    dependabotTab,
    codeScanningCard,
    dependabotAlertsCard,
  ],
});
